import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  SignUpHeaderWrapper: {
    display: 'flex',
    alignItems: 'left',
    flexDirection: 'column',
    maxWidth: 420,
    gap: theme.other.spacing._8,
  },
  SignUpHeaderWrapperCentered: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    flexDirection: 'column',
    alignSelf: 'stretch',
    minHeight: 126,
    maxWidth: 420,
    gap: theme.other.spacing._8,
    paddingLeft: 0,
    paddingRight: 0,
  },
  SignUpHeaderTitle: {
    textTransform: 'uppercase',
  },
  Icon: {
    marginBottom: 0,
  },
  IconCentered: {
    marginBottom: /* eslint-disable-line local-rules/use-theme-tokens */ 20,
  },
}));

export default useStyles;
